var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProtect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_482_1875)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.621414 3.47438C0.621414 1.61151 2.13331 0.0996094 3.99619 0.0996094H24.2448C26.1077 0.0996094 27.6196 1.60958 27.6196 3.47438V9.75531C27.6185 13.5932 26.3876 17.3298 24.1074 20.4169C21.8271 23.5041 18.6177 25.7793 14.9497 26.9088C14.4096 27.0765 13.8314 27.0765 13.2913 26.9088C9.62332 25.7793 6.41386 23.5041 4.13365 20.4169C1.85345 17.3298 0.622514 13.5932 0.621414 9.75531L0.621414 3.47438ZM14.1205 12.6345C15.2713 12.6345 16.3749 12.1773 17.1886 11.3636C18.0024 10.5499 18.4595 9.44626 18.4595 8.29548C18.4595 7.14471 18.0024 6.04107 17.1886 5.22735C16.3749 4.41363 15.2713 3.95649 14.1205 3.95649C12.9697 3.95649 11.8661 4.41363 11.0524 5.22735C10.2387 6.04107 9.78151 7.14471 9.78151 8.29548C9.78151 9.44626 10.2387 10.5499 11.0524 11.3636C11.8661 12.1773 12.9697 12.6345 14.1205 12.6345ZM22.1274 18.2135C21.1318 17.0674 19.9017 16.1484 18.5204 15.5186C17.1391 14.8888 15.6386 14.5629 14.1205 14.5629C12.6024 14.5629 11.1019 14.8888 9.72061 15.5186C8.33927 16.1484 7.10923 17.0674 6.11362 18.2135C8.03236 21.0402 10.8562 23.1295 14.1205 24.1376C17.3848 23.1295 20.2086 21.0402 22.1274 18.2135Z",
    fill: "#FF6B00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_482_1875"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.9982,
    height: 26.9982,
    fill: "white",
    transform: "translate(0.621414 0.0996094)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtect);
export default __webpack_public_path__ + "static/media/protect.05819b68d7bc067a51961b510c747850.svg";
export { ForwardRef as ReactComponent };